import { inputLabelClasses } from '@mui/material';
import { textInputColors } from '../constants';
const styleOverrides = {
  root: {
    [`&.${inputLabelClasses.root}.${inputLabelClasses.disabled}`]: {
      color: textInputColors.labelDisabled
    }
  }
};
export default {
  styleOverrides
};